<template>
  <div
    class="flex flex-col items-center mb-2"
    v-if="config?.camera?.status?.camera_mode === 1"
  >
    <div
      @click="toggleVideo()"
      class="aspect-square border-3 border-white hover:border-flyingeye-light active:opacity-50 p-1 w-8 rounded-full cursor-pointer"
    >
      <div
        class="bg-error w-full h-full rounded-full"
        :class="{ 'animate-pulse': isVideoOn }"
      ></div>
    </div>
    <div
      v-if="
        config?.camera?.status?.record_time != 0 &&
        config?.camera?.status?.record_time != undefined
      "
    >
      {{ recordTime(config.camera.status.record_time) }}s
    </div>
  </div>
</template>
<script>
import API from "@/utils/API.js";
export default {
  name: "Mode_Camera",
  components: {},
  props: {
    config: Object,
    video: Object,
  },

  setup() {
    return {};
  },

  methods: {
    async toggleVideo() {
      if (!this.isVideoOn) {
        var data = await API.put("camerarecordingstart", {
          DevId: this.config.deviceFamilly.this_dev_id,
          CamId: this.config.camera.payload_index,
        });

        var state = "on";
      } else {
        var data = await API.put("camerarecordingstop", {
          DevId: this.config.deviceFamilly.this_dev_id,
          CamId: this.config.camera.payload_index,
        });

        var state = "off";
      }

      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: "Caméra " + state,
      };
    },

    recordTime(secondes) {
      return (
        (secondes < 600 ? "0" : "") +
        Math.floor(secondes / 60) +
        ":" +
        (secondes % 60 < 10 ? "0" : "") +
        (secondes % 60)
      );
    },
  },

  computed: {
    isVideoOn() {
      return this.config?.camera?.status?.recording_state == 1;
    },
  },
};
</script>
